export default __webpack_public_path__ + "static/media/folder.e2d4baff.svg";